import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.date = {
      variant: 'text.base',
    };

    this.title = {
      variant: 'text.h2',
      textAlign: 'center',
      mt: 12,
      mb: 12,
    };

    this.articleHero = {
      maxHeight: [275, 580],
      width: '100%',
      objectFit: 'cover',
      mt: 13,
    };
  })()
);
